<template>
  <div class="header flex row-between" :class="{ fixed: isFixed }">
    <div class="logo flex col-center">
      <img src="@/assets/images/logo.png" />
    </div>
    <nav class="nav">
      <a href="/">
        <div>ホームページ</div>
        <div class="line" :class="$route.path === '/' ? 'active' : ''"></div>
      </a>
      <a href="/about">
        <div>私たちについて</div>
        <div class="line" :class="$route.path.indexOf('about') !== -1 ? 'active' : ''"></div>
      </a>
      <a href="/relation">
        <div>お問い合わせ</div>
        <div class="line" :class="$route.path.indexOf('relation') !== -1 ? 'active' : ''"></div>
      </a>
    </nav>
    <div class="hamburgers">
      <div class="iconfont icon-caidan" v-if="!isOpen" @click="handleIsOpen"></div>
    </div>
    <div class="hamburgers" v-if="isOpen">
      <div class="iconfont icon-guanbi" @click="handleIsOpen"></div>
      <div class="menu-box">
        <a href="/">
          <div class="menu-item">
            ホームページ
          </div>
        </a>
        <a href="/about">
          <div class="menu-item">
            私たちについて
          </div>
        </a>
        <a href="/relation">
          <div class="menu-item">
            お問い合わせ
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  props: {
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    handleIsOpen() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
<style lang="scss" scoped>
.fixed {
  position: fixed;
}
.header {
  //height: 6vh;
  padding: 0 80px 0 34px;
  width: 100%;
  z-index: 999;
  background: #050505;
  top: 0;
  height: 6vh;
  box-sizing: border-box;
  .logo {
    color: #303030;
    //font-family: 'Source Han Mono SC';
    font-style: normal;
    font-weight: 900;
    line-height: normal;

    img {
      height: 5vh;
    }
  }

  .nav {
    display: flex;
    gap: 40px;
    @media (max-width: $mobile-breakpoint) {
      display: none;
    }
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 14.4px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
    .line {
      border-radius: 1px;
      width: 24px;
      height: 3px;
      position: absolute;
      margin-top: 24px;
    }

    .active {
      background: #0098fd;
    }
  }

  .hamburgers {
    display: none; // 默认隐藏

    @media (max-width: $mobile-breakpoint) {
      display: flex;
      align-items: center;
    }
    .icon-caidan,
    .icon-guanbi {
      font-size: 1.5rem;
      color: #ffffff;
    }

    .menu-box {
      position: absolute;
      top: 6vh;
      left: 0;
      width: 100%;
      z-index: 999;
      background: $bg-color;
      display: flex;
      flex-direction: column;

      a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #303030;
        font-size: 30px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        border-bottom: 2px solid #e2e2e2;
        @media (max-width: $mobile-breakpoint) {
          font-size: 16px;
        }
        .menu-item {
          height: 180px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
